import React, { useState, useMemo } from "react";
import { useHits, useCurrentRefinements } from "react-instantsearch";

import Select from "./select"
import Result from "./result"
import Diagram from "./diagram"
import Modal from "./modal"
import Clear from "./clear"
// import { breakpoints } from "../../utils"

const ATTRIBUTES = [
    { label: "Installation Method", value: "ostendoInstallationMethod" },
    { label: "Trim Colour", value: "ostendoTrimColour" },
    { label: "Beam Angle", value: "ostendoBeamAngle" },
    { label: "Colour Temperature", value: "ostendoColourTemperature" },
    { label: "Power", value: "ostendoSystemPower", unit: "W" },
    { label: "Dimming Option", value: "ostendoDimmingOption" },
    { label: "Accessories", value: "ostendoAccessories", default: "" },
]

const ClearFilter = model =>
    (<Clear
        transformItems={items => items.filter(item => item.currentRefinement !== model)}
    />)



const showDiagram = ({ modalOpen, setModalOpen }) => {
    setModalOpen(!modalOpen)
};
function Specify({  modelName, modelCode, defaultAccessory  }){
    const { hits } = useHits();
    const { items } = useCurrentRefinements();

    const [modalOpen, setModalOpen] = useState( false );
    const toggleModal = () => setModalOpen(!modalOpen);
    const hit = hits[0];
    const showDiagram = hits.some((hit) => {
        const degrees = hit?.ostendoBeamAngle?.match(/(\d+)/g);
        return degrees?.length === 1 || degrees?.[0] === degrees?.[1];
    });
  const filteredItems = useMemo(
    () => items.filter((item) => item.attribute !== "ostendoModelName"),
    [items]
  );
   
    return (
         <div className="configurator__specify">
        <div>
            {ATTRIBUTES.map((attribute) => {
              
                    const defaultValue = attribute.label === "Accessories" && defaultAccessory !== "" ? defaultAccessory : attribute.default
                    return (
                                    <Select
                                        key={attribute.label}
                                        heading={attribute.label}
                                        modelName={modelName}
                                        modelCode={modelCode}
                                        attributeName={attribute.value}
                                        defaultRefinement={defaultValue}
                                        unit={attribute.unit}
                                    />
                    )
                },
            )}
           
            {ClearFilter(modelName)}
            <Result hit={hit} toggleModal={toggleModal} attributes={ATTRIBUTES} items={filteredItems} />
        </div>
        <div>
            <Diagram hit={showDiagram && hit} items={filteredItems} />
        </div>
        <Modal
            isOpen={modalOpen}
            toggleModal={toggleModal}
            hit={hit}
        />
    </div>
    )
}
export default Specify